'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createDomain = createDomain;

var _nestedHateoas = require('@unitedtraders/nested-hateoas');

var _models = require('./models');

var _services = require('./services');

var _Role = require('./Role');

var _enums = require('./enums');

function createDomain(applicationUrl, superAgent) {
  return new _nestedHateoas.Domain({
    applicationUrl: applicationUrl,
    domainName: 'luna-statements',
    superAgent: superAgent,
    Role: _Role.Role,
    enums: _enums.enums,
    defineModels: _models.defineModels,
    defineServices: _services.defineServices
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/statements-domain/dist/domain.js
// module id = 1428
// module chunks = 118